<template>
  <div class="bg-white rounded-2xl shadow-md p-6">
    <p v-if="!referent" class="text-center text-sm text-gray-500 py-4">{{ t("no_referent") }}</p>
    <div v-else class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-4">
      <StackedField :label="t('name')" :value="name" />
      <StackedField :label="t('email')" :value="referent.email" />
      <StackedField :label="t('phone')" :value="referent.phone" />
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { StackedField } from "@estaly/ui";

export default {
  components: { StackedField },

  props: {
    referent: { type: Object, default: null },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  computed: {
    name() {
      return [this.referent.firstName, this.referent.lastName].filter(Boolean).join(" ") || null;
    },
  },
};
</script>

<i18n src="./StoreReferentInformation.i18n.json"></i18n>
